<template>
  <Content>
    <Card>
      <Content :style="{ maxWidth: '40rem' }">
        <h1>Ankesat dhe Sugjerimet</h1>
        <br />
        <p>
          IFJB “PRO FINANCE HOME” synon të jetë pranë klientëve të saj, duke ofruar shërbime kualitative për të gjithë
          klientët! <br />
          Çdo sugjerim apo ankesë do të trajtohet me shumë seriozitet nga ana jonë, duke synuar çdo herë që së bashku do
          të mund të gjejmë zgjidhje për problemet që mund të hasni gjatë përdorimit të shërbimeve tona. Sugjerim -
          konsiderohet çdo propozim, prezentim i një ideje ose mendimi që mund të ndikojë në përmirësimin e produkteve
          apo shërbimeve të ofruara, për të qenë më të përshtatshme për klientët. Ankesë - konsiderohet një shprehje e
          pakënaqësisë, raportimin për mos-miratimin apo mos-funksionimin e një produkti apo shërbimi që ofron IFJB “PRO
          FINANCE HOME”, në një situat që mund të verifikohet. Ankesa nuk konsiderohen kërkesat për informim apo sqarim!
        </p>
        <br />
        <h2>Udhëzimi mbi paraqitjen e sygjerimit/ankesës tuaj!</h2>
        <br />
        <p>
          Përmes këtij udhëzimi do të informoheni mbi mundësinë e paraqitjes së ankesës tuaj ndaj Institucionit
          Financiar, që mund të ketë ndodhur si rezultat i ndonjë lëshimi teknik apo gabimi njerzor. Ankesat e dorzuara
          do ti nënshtrohen trajtimit vetëm atëherë kur dorëzohen nga vet klienti dhe janë të bazuara në argumente.
        </p>
        <br />

        <h2>Ku dhe si mund të paraqitni ankesën tuaj?</h2>
        <br />
        <p><strong>Çfarë duhet të përfshini në sygjerimin/ankesën tuaj:</strong></p>

        <CellGroup>
          <Cell title="1. Emri dhe mbiemri" />
          <Cell title="2. Numri personal" />
          <Cell title="3. Një numër telefoni, email adresën ose adresën postare" />
          <Cell title="4. Nëse është e aplikueshme, dërgoni dokumentet relevante që mbështesin çështjen tuaj" />

          <Cell title="With Switch" to="/PFH-Ankesa.pdf" target="_blank">
            <Icon slot="icon" type="ios-attach" :size="20" />
            Kliko për të marrë formën
          </Cell>
        </CellGroup>
        <br />

        <br />
        <h2>Për çdo sugjerim apo ankesë mund të na kontaktoni në:</h2>
        <br />
        <ContactInfo />
        <p>
          Sygjerimat/Ankesat Tuaja do të shqyrtohen në afatin prej 15 ditëve nga data e pranimit të saj (data e pranimit
          konsiderohet data kur ankesa është plotësuar me të gjitha informatat dhe dokumentet e nevojshme), ndërsa për
          rastet më të ndërlikuara ky afat mund të zgjatet deri në 30 ditë nga data e pranimit. Në raste të zgjatjes së
          afatit klienti do të njoftohet me kohë për këtë shtyerje dhe në rast se nevojiten informata ose dokumente
          shtesë klienti do të njoftohet për kohën brenda të cilës duhet t’i plotësoj). Përgjigja në ankesë është pa
          pages dhe do të jepet me shkrim, në formë elektronike apo përmes telefonit, varësisht nga zgjedhja e klientit.
          Përgjigja do të jetë në gjuhën në të cilën është lidhur marrëveshja e cila është subjekt i ankesës. Nëse
          klienti nuk është i kënaqur me përgjigje në ankesë, për zgjiidhjen e ankesës do të udhëzohet t’i drejtohet
          Bankës Qëndrore të Kosovës (BQK), Gjykatave apo institucioneve tjera relevante për zgjidhjen e ankesës. Gjatë
          periudhës së trajtimit të ankesave i gjithë procesi do të bazohet në udhëzimet nga rregullorja e BQK-së
          “RREGULLORE PËR PROCESIN E TRAJTIMIT TË ANKESAVE”.
        </p>

        <br />
        <h2>Afati kohor i trajtimit të ankesave</h2>
        <br />

        <p>
          Ne ju sugjerojm që parashtrimin e ankesës ta bëni në afatin kohor sa më të afërt, prej datës që ju konsideroni
          se keni argumente për ankesë.
        </p>
        <p>
          Ne do të ju njoftojm me rastin e pranimit të ankesës dhe numrin e references të cilin e mban ankesa, ndërsa
          për përgjigje përfundimtare do të ju kthejmë në afat prej 15 ditëve kalendarike pas pranimit të ankesës.
          Përgjigjën përfundimtare do të ju kthejm në të njëjtin kanal të cilin e keni deponuar ankesën, përveq në rast
          se klienti preferon që përgjigjen të i kthejmë në ndonjë nga kanalet e lartëpërmendura. Nëse nevojiten
          kontakte shtese lidhur me ankesën e deponuar atëherë numëri I referencës do të shërbej si referim.
        </p>
      </Content>
    </Card>
  </Content>
</template>

<script>
import ContactInfo from "../components/ContactInfo.vue";

export default {
  components: {
    ContactInfo,
  },
};
</script>
